import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import DailyIncomeChart from "./DailyIncomeChart";
import { dayTotalsOf } from "./incomeLabels";

// The dashboard's day by day income, all the kiosks together: the chart alone. Each
// kiosk's days are a page of their own (DailyIncome.js), which the link opens on the
// same days.
const DailyIncomeCard = ({ daily, error, target }) => {
  const days = daily ? daily.days : [];
  const values = daily ? dayTotalsOf(daily) : [];
  const first = days[0];
  const last = days[days.length - 1];

  return (
    <section className="p-5 mb-6 bg-white border border-gray-100 rounded-xl shadow-xs dark:bg-gray-800 dark:border-gray-700">
      <div className="flex items-start justify-between gap-4 mb-2">
        <div>
          <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100">Өдөр тутмын орлого</h2>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            {days.length > 0 && `${first} — ${last} · `}Бүх киоскийн нийлбэр
          </p>
        </div>
        <Link
          to={days.length > 0 ? `/income?from=${first}&to=${last}` : "/income"}
          className="flex-shrink-0 text-sm font-semibold text-purple-600 hover:underline dark:text-purple-400"
        >
          Дэлгэрэнгүй →
        </Link>
      </div>
      {error ? (
        <p className="py-10 text-sm text-center text-gray-500 dark:text-gray-400">{error}</p>
      ) : values.every((value) => !value) ? (
        <p className="py-10 text-sm text-center text-gray-400">Харуулах мэдээлэл алга.</p>
      ) : (
        <DailyIncomeChart days={days} values={values} target={target} height={260} />
      )}
    </section>
  );
};

DailyIncomeCard.propTypes = {
  daily: PropTypes.object,
  error: PropTypes.string,
  // The daily target, or 0 without one
  target: PropTypes.number,
};

export default DailyIncomeCard;
